var map = {
	"./ADA.svg": 125,
	"./BTC.svg": 126,
	"./DOGE.svg": 127,
	"./DOT.svg": 128,
	"./ETC.svg": 129,
	"./ETH.svg": 130,
	"./EUR.svg": 131,
	"./RUB.svg": 132,
	"./SOL.svg": 133,
	"./TRX.svg": 134,
	"./USD.svg": 135,
	"./USDT.svg": 58,
	"./XRP.svg": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;